<template>
    <div class="basic">
        <div class="manage-title"><em class="txt">其他信息</em></div>
        <div class="infoBox margin-top-20">
            <div class="item flex">
                <p class="tit">企业logo</p>
                <ul class="pic flex">
                    <li v-if="enterprise_logo"><img :src="enterprise_logo" class="logo radius"></li>
                </ul>
            </div>
            <div class="item flex">
                <p class="tit">企业照片</p>
                <ul class="pic flex" v-if="enterprise_img">
                    <li v-for="item in enterprise_img" :key="item.id">
                        <img :src="item" class="radius">
                    </li>
                </ul>
            </div>
            <div class="item flex">
                <p class="tit">营业执照</p>
                <ul class="pic flex">
                    <li v-if="business_license"><img :src="business_license" class="radius"></li>
                </ul>
            </div>
            <div class="item flex">
                <p class="tit">其他证件</p>
                <ul class="pic flex" v-if="other_documents">
                    <li v-for="item in other_documents" :key="item.id"><img :src="item" class="radius"></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'InfoPic',
    props: {
        enterprise_logo: String,
        enterprise_img: Array,
        business_license: String,
        other_documents: Array
    }
}
</script>
<style scoped></style>
